"use client";

import { ArrowRight, Feather, Sparkles, Wind } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "TAI CHI",
  description: "Tai Chi Chuan ist eine chinesische Kampfkunst, die auf dem Prinzip von Yin und Yang beruht. Die weichen, lockeren, runden Bewegungen mit oder ohne Waffe trainieren gleichermaßen Körper und Geist.",
  icon: Feather,
  link: "/WhatIsTaiChiPage"
}, {
  title: "Qi Gong & Yoga",
  description: "Indisches Hatha Yoga und chinesisches Qi Gong bieten einen großen Schatz an Übungen, die körperliche und empotional-geistige Blockaden lösen und die Energie wieder harmonisch fließen lassen.",
  icon: Sparkles,
  link: "https://huge-sunbird.10web.cloud/qi-gong-yoga/"
}, {
  title: "ACHTSAMKEIT & MEDITATION",
  description: "Leichtigkeit im Umgang mit den Hindernissen des Lebens - Meditation und Achtsamkeitspraxis sind ein 2600 Jahre lang erprobter Königsweg zu geistiger Klarheit und Herzensfrieden.",
  icon: Wind,
  link: "/TrainingInHarmonyPage"
}];
export default function HealingMethods() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="108104" id="unsere-disziplinen" className="py-24 md:py-32 bg-[#FAF6F1] overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-sans font-bold text-4xl md:text-5xl text-center text-[#4A5D23] mb-16 md:mb-24 tracking-tighter">
            Unsere Disziplinen
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {services.map((service, i) => <div key={i} data-index={i} className="group h-full">
                <Card className={`h-full border-none p-8 md:p-10 transition-all duration-700 hover:brightness-110 flex flex-col rounded-lg overflow-hidden relative bg-cover bg-center shadow-md ${i === 0 ? "bg-[url('https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?auto=format&fit=crop&q=80')]" : i === 1 ? "bg-[url('https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&q=80')]" : "bg-[url('https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&q=80')]"}`}>
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2C5F63]/70 via-transparent to-transparent opacity-100 transition-opacity duration-500 group-hover:opacity-80" />
                  
                  <div className="mb-8 relative z-10">
                    <service.icon className="w-12 h-12 text-transparent stroke-[1.5] transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  
                  <h3 className="font-sans text-3xl text-white mb-4 relative z-10 !font-bold text-center">
                    {service.title}
                  </h3>
                  
                  <p className={`text-white/90 font-medium leading-relaxed flex-grow mb-8 text-lg relative z-10 ${i === 2 ? "min-h-[140px]" : ""}`}>
                    {service.description}
                  </p>
                  
                  <div className="mt-auto pt-4 border-t border-white/20 relative z-10">
                    <Link to={service.link} className="inline-flex items-center text-sm font-bold text-white tracking-wider uppercase transition-all group-hover:text-white/80">
                      <span className="underline underline-offset-8 decoration-transparent transition-colors duration-300 group-hover:decoration-white/50">
                        Details ansehen
                      </span>
                      <ArrowRight className="ml-3 w-4 h-4 transition-transform duration-300 group-hover:translate-x-2 text-white" />
                    </Link>
                  </div>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}